import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.6875 12.0781C1.6875 14.8132 2.774 17.4362 4.70797 19.3702C6.64193 21.3042 9.26496 22.3906 12 22.3906C14.7351 22.3906 17.3581 21.3042 19.2921 19.3702C21.226 17.4362 22.3125 14.8132 22.3125 12.0781C22.3125 9.34308 21.226 6.72006 19.2921 4.78609C17.3581 2.85212 14.7351 1.76562 12 1.76562C9.26496 1.76562 6.64193 2.85212 4.70797 4.78609C2.774 6.72006 1.6875 9.34308 1.6875 12.0781Z",
      stroke: "#627258",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.25 10.2031H12V16.7656",
      stroke: "#627258",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.25 16.7656H15.75",
      stroke: "#627258",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 7.39062V5.51562",
      stroke: "#627258",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }